import { Injectable } from "@angular/core";

//import * as moment from "moment";
import { RandonneursService } from "app/shared/services/randonneurs.service";
import { AuthCredentials } from "app/shared/data/auth-credentials";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { AuthRegister } from "app/shared/data/auth-register";

import { Sha256 } from "app/shared/services/sha256";
import { AuthData } from "app/core/data/auth-data";


@Injectable()
export class AuthService {

    //public loggedIn:boolean=false;

    private authSubject_:BehaviorSubject<any> =  new BehaviorSubject(null);
    public emitter:Observable<AuthData>;

    constructor(private randonneursService: RandonneursService, private sha256: Sha256) {
        this.emitter = this.authSubject_.asObservable();
        this.tryAutologin();
    }

    tryAutologin() {
        let loginEmail = localStorage.getItem('loginUser');
        if (loginEmail!=null && loginEmail!='') {
            let loginToken = localStorage.getItem('loginToken');
            this.loginWithToken(loginEmail, loginToken).then(
                ok=>console.log("Autologin succeeded"),
                err=>console.log("Autologin failed: " + err)
            )
        }
    }

    /** return null if ok, error otherwise */
    login(email:string, password:string ):Promise<String> {
        let p:string = <string>this.sha256.sha256_digest(password);
        return this.loginWithToken(email, p);
    }

    loginWithToken(email:string, token:string):Promise<String> {
        let promise = new Promise<String>((resolve, reject) => {
            let creds = new AuthCredentials(email, token);
            this.randonneursService.login(creds)
                .subscribe(
                    (res) => {
                        if (res["error"]==null) {
                            //this.setSession(res);
                            let data = new AuthData(res["user"]["id"], res["user"]["role"], res["user"]["name"], res["user"]["email"])
                            this.setAuthState_(data);
                            localStorage.setItem('loginUser', email);
                            localStorage.setItem('loginToken', token);
                            resolve();
                        } else {
                            this.setAuthState_(null);
                            resolve(res["error"]);
                        }
                    },
                    (error) => {
                        console.log("GOT ERR", error);
                        this.logout();
                        reject(error);
                    }
                );
            }
        );

        return promise;
        /*
        {"error":"Non autoris\u00e9: credentials invalide."}
        {"id":"1238","user":{"error":null,"id":"1238","role":"user,admin,notes","name":"C\u00e9dric Dutoit","email":"dutoitc@shimbawa.ch"}}
        */
    }

    /** return null if ok, error otherwise */
    register(authRegister: AuthRegister):Promise<String> {
        authRegister.password = <string>this.sha256.sha256_digest(authRegister.password);
            let promise = new Promise<String>((resolve, reject) => {
            this.randonneursService.register(authRegister)
                .subscribe(
                    (res) => {
                        console.log("Register got ", res);
                        if (res["success"]==true) {
                          resolve("OK")
                        } else {
                          resolve(res["error"]);
                        }
                    },
                    (error) => {
                        console.log("GOT ERR", error);
                        reject(error);
                    }
                );
            }
        );

        return promise;
    }

    /** return null if ok, error otherwise */
    confirmid(code: String):Promise<String> {
            let promise = new Promise<String>((resolve, reject) => {
            this.randonneursService.confirmid(code)
                .subscribe(
                    (res) => {
                        console.log("ConfirmID got ", res);
                        if (res["success"]==true) {
                          resolve("OK")
                        } else {
                          resolve(res["error"]);
                        }
                    },
                    (error) => {
                        console.log("GOT ERR", error);
                        reject(error);
                    }
                );
            }
        );

        return promise;
    }

    /*
    private setSession(res) {
        //{"id":"1238","user":{"error":null,"id":"1238","role":"user,admin,notes","name":"C\u00e9dric Dutoit","email":"dutoitc@shimbawa.ch"}}

        //const expiresAt = moment().add(authResult.expiresIn,'second');
        //this.loggedIn=true;
        console.log("setSession", res);


        let id=res["user"]["id"];
        let name=res["user"]["name"];
        let roles=res["user"["role"]];
        let error = res["error"];
        console.log("Set name to " + this.name, res);
        //localStorage.setItem('id_token', authResult.idToken);
        //localStorage.setItem("expires_at", JSON.stringify(expiresAt.valueOf()) );
    }          */

    /*logout() {
        localStorage.removeItem("id_token");
        this.name="";
        this.roles="";
        //localStorage.removeItem("expires_at");
    }*/

    logout():void {
        this.setAuthState_(null);
        localStorage.removeItem('loginUser');
        localStorage.removeItem('loginToken');
      }

      private setAuthState_(data: AuthData):void {
        this.authSubject_.next(data);
      }

    /*
    public isLoggedIn() {
        return moment().isBefore(this.getExpiration());
    }

    isLoggedOut() {
        return !this.isLoggedIn();
    }

    getExpiration() {
        const expiration = localStorage.getItem("expires_at");
        const expiresAt = JSON.parse(expiration);
        return moment(expiresAt);
    }
    */
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/core/security/auth.service.ts